import { render, staticRenderFns } from "./UnifiedCardPayment.vue?vue&type=template&id=2072a863&scoped=true"
import script from "./UnifiedCardPayment.vue?vue&type=script&lang=js"
export * from "./UnifiedCardPayment.vue?vue&type=script&lang=js"
import style0 from "./UnifiedCardPayment.vue?vue&type=style&index=0&id=2072a863&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2072a863",
  null
  
)

export default component.exports